import React from 'react';
import { Link } from 'react-router-dom';
import './BlogItem.css';

function BlogItem({ fileName, title, text, image, date, tags, isLatest = false }) {
  return (
    <Link
      to={`/blog/${fileName}`}
      className="blog-item group grid overflow-hidden rounded-lg border border-[var(--border-color)] bg-[var(--bg-card)] text-[var(--text-secondary)] no-underline shadow-sm transition hover:-translate-y-0.5 hover:border-[var(--accent-gold)] hover:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-gold)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-primary)] md:grid-cols-[14rem_1fr]"
    >
      <div className="blog-image-frame flex items-center justify-center border-b border-[var(--border-color)] bg-[var(--bg-tertiary)] p-4 md:border-b-0 md:border-r">
        <img src={image} className="max-h-full max-w-full object-contain transition duration-300 group-hover:scale-[1.03]" alt={title} />
      </div>
      <article className="p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          {date && (
            <span className="rounded-full border border-[var(--border-color)] px-3 py-1 text-xs font-semibold text-[var(--text-secondary)]">
              {date}
            </span>
          )}
          {isLatest && (
            <span className="rounded-full bg-[var(--accent-gold-fill)] px-3 py-1 text-xs font-semibold text-neutral-950">
              Latest
            </span>
          )}
        </div>
        <h2 className="blog-title text-xl font-bold leading-tight text-[var(--text-primary)] transition group-hover:text-[var(--accent-gold)]">
          {title}
        </h2>
        <p className="blog-text mt-3 text-sm leading-relaxed text-[var(--text-secondary)] md:text-base">{text}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((tag, idx) => (
            <span key={idx} className="rounded-full bg-[var(--accent-green)] px-3 py-1 text-xs font-semibold text-white">
              {tag}
            </span>
          ))}
        </div>
        <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--accent-gold)]">
          Read article
          <span aria-hidden="true">→</span>
        </span>
      </article>
    </Link>
  );
}

export default BlogItem;
